import { memo, useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box } from '@alf/uikit';
import { useComponentConfig, useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { USER_ROLES, UserContext } from '@namespace/user';
import GamesSection from '../../../../../common/GamesSection';
import {
  IS_USE_PLEX_API,
  ROWS_WITH_GAMES,
  SEARCH_POPULAR_CATEGORY_GAMES_LIST_ID
} from '../../../../../constants';
import {
  useCategory,
  useExcludedActiveBonusGamesList
} from '../../../../../store';
import RecommendedGamesOnCasinoSearch from '../../../RecommendedGamesOnCasinoSearch';
import { useBottomCategoryGamesList } from '../../../useBottomCategoryGamesList';

import styles from './index.module.css';

const BottomCategoryGamesList = ({
  casinoType,
  feedName,
  casinoSearchBottomCategory,
  isGamesResultEmpty = true,
  recommendedCategory
}) => {
  const { t } = useI18n();
  const config = useComponentConfig();
  const { isDesktop } = useDeviceStore();

  const [user] = useContext(UserContext);
  const { excludedBonusGamesList } = useExcludedActiveBonusGamesList();
  const { isGameCardsMinimisedConfig = false } = useOtherSettings();
  const { role } = user;
  const isUser = role === USER_ROLES.USER;

  let casinoSearchBottomCategoryName = casinoSearchBottomCategory[casinoType];
  const hasRecommendedGames = recommendedCategory?.categoryGames?.length > 0;

  if (
    typeof casinoSearchBottomCategoryName === 'object' &&
    casinoSearchBottomCategoryName !== null
  ) {
    const { userCategory, guestCategory } = casinoSearchBottomCategoryName;
    casinoSearchBottomCategoryName = isUser ? userCategory : guestCategory;
  }

  const {
    page,
    handlePageChange,
    bottomCategoryGames,
    isAllGamesLoaded,
    isLoading
  } = useBottomCategoryGamesList({
    casinoSearchBottomCategoryName,
    feedName,
    casinoType
  });

  const bottomCategory = useCategory(
    casinoSearchBottomCategoryName,
    feedName,
    casinoType
  );

  return (
    <>
      {hasRecommendedGames && isGamesResultEmpty && (
        <RecommendedGamesOnCasinoSearch
          kind={ROWS_WITH_GAMES.ALL}
          {...(isDesktop && {
            classNames: {
              recommendedHeaderDesktop: styles.recommendedHeaderDesktop,
              searchGameSectionTitle: styles.searchGameSectionTitle
            }
          })}
        />
      )}

      {!hasRecommendedGames &&
        isGamesResultEmpty &&
        !!bottomCategoryGames?.length && (
          <Box
            className={clsx([
              styles.bottomCategoryGames,
              isGameCardsMinimisedConfig &&
                !isDesktop &&
                styles.bottomCategoryGamesMinimised
            ])}
          >
            <GamesSection
              config={config}
              title={t(bottomCategory?.title)}
              games={bottomCategoryGames}
              classNames={{
                searchGamesList: styles.searchGamesList,
                searchGameSectionTitle: styles.searchGameSectionTitle,
                searchGameSectionTitleWrapper:
                  styles.searchGameSectionTitleWrapper
              }}
              isPaginationEnabled={IS_USE_PLEX_API || !isDesktop}
              categoryName={SEARCH_POPULAR_CATEGORY_GAMES_LIST_ID}
              excludedBonusGamesList={excludedBonusGamesList}
              {...(IS_USE_PLEX_API
                ? {
                    isPlexAllGamesLoaded: isAllGamesLoaded,
                    kind: ROWS_WITH_GAMES.ALL_WITH_PLEX_PAGINATION,
                    isPlexLoading: isLoading,
                    page,
                    handlePageChange
                  }
                : {
                    kind: ROWS_WITH_GAMES.ALL,
                    handlePageChange,
                    page
                  })}
            />
          </Box>
        )}
    </>
  );
};
export default memo(BottomCategoryGamesList);

BottomCategoryGamesList.propTypes = {
  casinoType: PropTypes.string,
  feedName: PropTypes.string,
  casinoSearchBottomCategory: PropTypes.shape({
    casino: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        userCategory: PropTypes.string,
        guestCategory: PropTypes.string
      })
    ]),
    casinoLive: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        userCategory: PropTypes.string,
        guestCategory: PropTypes.string
      })
    ]),
    instantGames: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        userCategory: PropTypes.string,
        guestCategory: PropTypes.string
      })
    ])
  })
};
